export const SCOPE_OPTIONS = [
  'markets:read',
  'trade:write',
  'positions:read',
  'auto_exit:write',
  'redeem:write',
];

const SCOPE_LABEL_KEYS = {
  'markets:read': 'account.apiKeys.scopeLabels.marketsRead',
  'trade:write': 'account.apiKeys.scopeLabels.tradeWrite',
  'positions:read': 'account.apiKeys.scopeLabels.positionsRead',
  'auto_exit:write': 'account.apiKeys.scopeLabels.autoExitWrite',
  'redeem:write': 'account.apiKeys.scopeLabels.redeemWrite',
};

export function getScopeLabel(t, scope) {
  const labelKey = SCOPE_LABEL_KEYS[scope];
  if (!labelKey) return scope;
  return t(labelKey);
}
